import AccessSettingsDataGrid from './AccessSettingsDataGrid';

export default AccessSettingsDataGrid;
